module.exports = __webpack_public_path__ + "media/images/Star29-f9ac8ddd.png";